import { v4 as uuidv4 } from "uuid";
import {
  BackendCart,
  CartPackages
} from "@/interfaces/packages/sales_packages";

export const convertCart = (cart: BackendCart[]) => {
  if (!cart) {
    return [];
  }
  return cart.map(
    item =>
      ({
        id: uuidv4(),
        dates: item.dates,
        package: {
          id: item.package_id,
          name: item.package_name,
          price: item.price_per_package,
          description: item.package_description,
          taxText: item.tax_text
        }
      } as CartPackages)
  );
};
